import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId, } from "react";
import { cn } from "./cn.js";
const control = "w-full min-h-12 rounded-field border border-line bg-surface/80 px-4 text-base text-fg placeholder:text-muted/70 " +
    "transition-colors duration-150 focus:border-primary focus:ring-4 focus:ring-primary/20 focus:outline-none aria-[invalid=true]:border-danger sm:text-sm";
export const Input = forwardRef(function Input({ className, ...rest }, ref) {
    return _jsx("input", { ref: ref, className: cn(control, className), ...rest });
});
export const Textarea = forwardRef(function Textarea({ className, ...rest }, ref) {
    return _jsx("textarea", { ref: ref, className: cn(control, "py-3", className), ...rest });
});
export const Select = forwardRef(function Select({ className, children, ...rest }, ref) {
    return (_jsx("select", { ref: ref, className: cn(control, "pr-9", className), ...rest, children: children }));
});
/** Label + control + hint/error, wired up for screen readers. */
export function Field({ label, hint, error, children, className }) {
    const id = useId();
    const hintId = `${id}-hint`;
    const props = { id };
    if (error)
        props["aria-invalid"] = true;
    if (error || hint)
        props["aria-describedby"] = hintId;
    return (_jsxs("div", { className: cn("flex flex-col gap-1.5", className), children: [_jsx("label", { htmlFor: id, className: "text-sm font-medium text-fg", children: label }), children(props), (error || hint) && (_jsx("p", { id: hintId, className: cn("text-xs", error ? "text-danger" : "text-muted"), children: error || hint }))] }));
}
//# sourceMappingURL=Field.js.map